module.exports = __webpack_public_path__ + "media/images/fill-action-icon-257c4c85d7ba834090b2ddbc0a6ee2ee.svg";